import { css, Theme, Interpolation } from '@emotion/react'
import { buttonBaseClasses } from '@mui/material'

export const row: (error?: boolean) => Interpolation<Theme> = (error) => (theme) =>
  css`
    width: fit-content;
    min-width: 100%;
    display: flex;
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(0.75)};
    background: ${theme.backgrounds.backgroundFour};
    border: 1px solid ${error ? theme.colors.red : theme.backgrounds.backgroundOne};
    box-shadow: ${theme.boxShadows.small};
    border-radius: 14px;
  `

export const columns: (columnsCount: number) => Interpolation<Theme> = (columnsCount) => (theme) =>
  css`
    min-width: ${columnsCount * 160}px;
    width: 100%;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(${columnsCount}, 1fr);
    gap: ${theme.spacing(2)};
    padding: 0 ${theme.spacing(1)};
  `

export const buttons: (isColumnsEditable: boolean) => Interpolation<Theme> = (isColumnsEditable) => (theme) =>
  css`
    min-width: ${isColumnsEditable ? 116 : 76}px;
    display: flex;
    align-items: center;
    justify-content: right;
    gap: ${theme.spacing(0.5)};
  `

export const iconButton: Interpolation<Theme> = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const dndIcon: Interpolation<Theme> = css`
  min-width: 20px;
`
